const API_BASE = process.env.REACT_APP_API_URL || 'https://api.alburaqscents.com';
const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://alburaqscents.com';
const SHOP_URL = (process.env.REACT_APP_SHOP_URL || 'http://localhost:3002').replace(/\/$/, '');

const TECHNICAL_PATTERNS = [
  /REACT_APP_/i,
  /invalid response/i,
  /failed to fetch/i,
  /networkerror/i,
  /unexpected token/i,
  /<!doctype/i,
  /not valid json/i,
  /request failed \(\d+\)/i,
];

function isTechnicalMessage(message = '') {
  return TECHNICAL_PATTERNS.some((pattern) => pattern.test(message));
}

function getUserErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const message = typeof error === 'string' ? error : error?.message;
  if (!message || isTechnicalMessage(message)) {
    if (error) console.error(error);
    return fallback;
  }
  return message;
}

async function parseJsonResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    console.error('API returned non-JSON response', {
      status: response.status,
      url: response.url,
      contentType,
    });
    throw new Error('Unable to load data. Please try again later.');
  }

  let result;
  try {
    result = await response.json();
  } catch (parseError) {
    console.error('Failed to parse API response', parseError);
    throw new Error('Unable to load data. Please try again later.');
  }

  if (!response.ok || result.success === false) {
    if (result.message && !isTechnicalMessage(result.message)) {
      throw new Error(result.message);
    }

    console.error('API request failed', { status: response.status, result });
    throw new Error('Something went wrong. Please try again later.');
  }

  return result;
}

export { API_BASE, WEBSITE_URL, SHOP_URL, parseJsonResponse, getUserErrorMessage };
